import { AdjustChip, AdjustChipGroup, AdjustGroupHeader, AdjustNote, AdjustSlider } from '../AdjustControlPrimitives.component'
import { DRAW_SIZE_RANGE, DrawTool } from '../adjust.types'

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import { AdjustSwatches } from '../AdjustSwatches.component'
import AutoFixNormalOutlinedIcon from '@mui/icons-material/AutoFixNormalOutlined'
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined'
import CropSquareOutlinedIcon from '@mui/icons-material/CropSquareOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import DrawOutlinedIcon from '@mui/icons-material/DrawOutlined'
import { FC, ReactNode } from 'react'
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule'
import { MUIButton } from 'components/common/MUIButton'
import { Stack } from '@mui/material'
import { useAdjustEditor } from '../AdjustEditor.context'
import { useTranslation } from 'react-i18next'

const DRAW_TOOLS: Array<{ id: DrawTool, icon: ReactNode }> = [
  { id: 'pen', icon: <DrawOutlinedIcon /> },
  { id: 'line', icon: <HorizontalRuleIcon /> },
  { id: 'arrow', icon: <ArrowRightAltIcon /> },
  { id: 'rectangle', icon: <CropSquareOutlinedIcon /> },
  { id: 'ellipse', icon: <CircleOutlinedIcon /> },
  { id: 'eraser', icon: <AutoFixNormalOutlinedIcon /> },
]

/** Pen, line, arrow, rectangle, ellipse and an eraser for the drawing — all saved into the photo */
export const AnnotateControls: FC<{ disabled?: boolean }> = ({ disabled = false }) => {
  const { t } = useTranslation(['photo_studio_editing'])
  const { doc, apply, drawTool, setDrawTool, drawColor, setDrawColor, drawSize, setDrawSize, drawOpacity, setDrawOpacity } = useAdjustEditor()
  const isEraser = drawTool === 'eraser'

  return (
    <Stack gap="1.2rem">

      <AdjustChipGroup ariaLabel={t('manual_tools.ANNOTATE')}>
        {DRAW_TOOLS.map(tool => (
          <AdjustChip key={tool.id} label={t(`adjust.annotate.tool.${tool.id}`)} icon={tool.icon} selected={drawTool === tool.id} disabled={disabled} onClick={() => setDrawTool(tool.id)} />
        ))}
      </AdjustChipGroup>

      {!isEraser && (
        <>

          <AdjustGroupHeader title={t('adjust.color')} />

          <AdjustSwatches value={drawColor} onChange={setDrawColor} disabled={disabled} />

        </>
      )}

      <AdjustSlider label={t('adjust.annotate.size')} value={drawSize} valueLabel={String(drawSize)} min={DRAW_SIZE_RANGE.min} max={DRAW_SIZE_RANGE.max} disabled={disabled} onChange={setDrawSize} />

      {!isEraser && (
        <AdjustSlider label={t('adjust.annotate.opacity')} value={drawOpacity} valueLabel={`${drawOpacity}%`} min={10} max={100} disabled={disabled} onChange={setDrawOpacity} />
      )}

      <AdjustNote>{t('adjust.annotate.text_hint')}</AdjustNote>

      <MUIButton type="secondaryBorder" size="sm" startIcon={<DeleteOutlineIcon />} disabled={disabled || !doc.shapes.length} onClick={() => apply({ type: 'clearShapes' })}>
        {t('adjust.annotate.clear')}
      </MUIButton>

    </Stack>
  )
}
